import styled from 'styled-components'
import { media } from '../../../utils/mediaQuery'

export const Container = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  align-items: stretch;
  gap: ${({ theme }) => theme.spacing.medium};
  flex: ${({ $fullWidth }) => ($fullWidth ? '1' : 'initial')};
  flex-wrap: wrap;

  @container (max-width: 550px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: ${({ theme }) => theme.spacing.small};
    width: 100%;
  }

  @container (max-width: 380px) {
    gap: ${({ theme }) => theme.spacing.xsmall};
  }

  ${media.tabletDown} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: ${({ theme }) => theme.spacing.small};
    width: 100%;
  }

  ${media.mobileOnly} {
    gap: ${({ theme }) => theme.spacing.xsmall};
  }

  @media print {
    display: flex !important;
    width: 100%;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: nowrap;
  }
`
